export const ELECTRONICBANK = {
  GUARANTEE: 'GUARANTEE',
  CLEAR: 'CLEAR',
  SET_EDIT_ID: 'SET_EDIT_ID',
}
